<template>
  <div>
    <div class="page_contents"></div>
    <div id="container">
      <h3>이용약관</h3>
      <hr />
      <p>홈 &gt; 이용약관</p>
      <dl>
        <dt>제 1 조 (목적)</dt>
        <dd>1. 이 약관은 주식회사 파트너전자입찰시스템(이하 “회사”)이 운영하는 입찰정보서비스(한글명 : 주식회사 파트너전자입찰시스템 | 도메인명: www.ptbid.net 이하 “서비스”)의 회원가입 및 서비스 이용에 “회사”와 회원 간의 권리 의무 및 책임사항을 규정함을 목적으로 합니다.</dd>
      </dl>
      <dl>
        <dt>제 2 조 (용어의 정의)</dt>
        <dd>
          <p>1) 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.</p>
          <p class="m20">
            ㉠ 이용자란 “서비스”에 접속하거나 방문하여 이 약관에 따라 “회사”가 제공하는 서비스를 받는 회원 및 비회원을 통칭합니다. <br />
            ㉡ '회원'이라 함은 “회사”에 개인정보를 제공하고 “서비스”로부터 사이트에 온라인 회원으로 등록을 한 고객으로서, "회사"의 정보를 지속적으로 제공받으며, “회사”가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다. <br />
            ㉢ "비회원"이라 함은 회원에 가입하지 않고, “회사”가 제공하는 서비스를 이용하는 자를 말합니다. <br />
            ㉣ 싸이트라 함은 "회사"가 서비스를 제공하기 위해 인터넷공간상에 마련한 모든 웹site를 말합니다. <br />
            ㉤ '이용계약' 이라 함은 서비스 이용과 관련하여 “회사”와 회원 간에 체결 하는 계약을 말합니다. <br />
            ㉥ '회원 ID'라 함은 회원의 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 “회사”가 부여하는 문자와 숫자의 조합을 말합니다. <br />
            ㉦ '비밀번호'라 함은 회원이 부여 받은 회원 ID와 일치된 회원임을 확인하고 회원의 권익보호를 위하여 회원이 선정한 문자와 숫자의 조합을 말합니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 3 조(이용약관의 효력 및 개정)</dt>
        <dd>
          <p>
            1. 이 약관은 서비스 메뉴를 통하여 공지하거나 기타의 방법으로 회원에게 공지함으로써 효력이 발생합니다.<br />
            2. “회사”는 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.<br />
            3. “회사”가 이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 "싸이트" 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.<br />
            4. “회사”가 이 약관을 개정한 경우에는 해당 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용되는 것을 원칙으로 합니다. 다만 “회원”이 상당한 기간 내에 개정 약관에 대한 거부의사를 표명하지 아니 하는 때에는 변경
            약관에 동의 한 것으로 간주, 개정 약관의 적용을 받는 것으로 본다”는 취지의 통지를 하였음에도 회원이 이를 수신한 후 15일 이내에 거부 의사를 표명하지 아니한 경우 해당 개정약관이 적용됩니다. <br />
            5. 본 약관의 개정과 관련하여 거부 의사를 표명한 회원은 회원탈퇴를 할 수 있습니다. <br />
            단 거부의사가 있음에도 불구하고, 3),4)항에 정해진 바에 따른 “회사”의 고지가 있은 후에 30일이내에 회원탈퇴를 하지 않은 회원은 개정약관에 동의한 것으로 봅니다.<br />
            6. 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 정부가 제정한 전자거래 소비자<br />
            보호지침 및 관계법령 또는 상 관례에 따릅니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 4 조 (이용계약의 성립)</dt>
        <dd>1. 이용계약은 회원의 이용신청에 대하여 “회사”의 이용승낙으로 성립합니다.</dd>
      </dl>
      <dl>
        <dt>제 5 조 (이용 신청 및 약관의 동의)</dt>
        <dd>1. 이용신청자는 본 약관에 동의한다는 의사표시를 한 후 회사가 정한 양식에 따라 회원가입을 신청합니다.</dd>
      </dl>
      <dl>
        <dt>제 6 조 (이용신청의 승낙)</dt>
        <dd>
          <p>
            1. “회사”는 제 5조에 따른 이용 신청고객에 대하여 서비스 이용신청을 승낙합니다.<br />
            2. “회사”는 다음에 해당하는 경우에 그 신청에 대한 승낙 제한사유가 해소될 때까지 승낙을 유보할 수 있습니다.
          </p>
          <p class="m20">
            ㉠ 등록 내용에 허위, 기재누락, 오기가 있는 경우 <br />
            ㉡ 서비스 관련 설비에 여유가 없는 경우<br />
            ㉢ 기술상 지장이 있는 경우<br />
            ㉣ 기타 회사에서 필요하다고 인정되는 경우
          </p>
          <p>3. 회사는 다음에 해당하는 경우에는 이를 승낙하지 아니 할 수 있습니다.</p>
          <p class="m20">
            ㉠ 제 11조 및 제12조에 의하여 이전에 회원자격을 상실한 적이 있는 경우<br />
            ㉡ 다른 사람의 명의를 사용하여 신청한 경우<br />
            ㉢ “서비스”의 정보를 도용할 목적으로 신청하였을 경우<br />
            ㉣ 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청한 경우<br />
            ㉤ 기타 회사 소정의 이용신청요건을 충족하지 못하는 경우
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 7 조 (회원ID 부여 및 변경)</dt>
        <dd>
          <p>
            1. 회사는 회원제서비스 회원에 대하여 약관에 정하는 바에 따라 회원ID를 부여합니다. <br />
            2. "회사"는 회원ID에 의하여 고객계좌 입금 등 모든 제반회원 관리업무를 수행하므로, 한번 가입한 회원ID는 변경을 불가하며 다음 각 호에 해당하는 경우에만 회원 또는 "회사"의 요청에 의하여 변경할 수 있습니다.
          </p>
          <p class="m20">
            ㉠ 회원ID가 회원의 전화번호 또는 주민등록번호 등으로 등록되어 사생활 침해가 우려 되는 경우 <br />
            ㉡ 타인에게 혐오감을 주거나 미풍양속에 어긋나는 경우
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 8조 (회원의 ID 및 비밀번호에 대한 의무)</dt>
        <dd>
          1. 회원ID와 비밀번호에 관한 관리책임은 회원에게 있습니다. <br />
          2. 회원은 자신의 회원ID 및 비밀번호를 제3자에게 이용하게 해서는 안 됩니다.<br />
          3. 회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 "회사"에 통보하고, "회사"의 안내가 있는 경우 그에 따라야 합니다.
        </dd>
      </dl>
      <dl>
        <dt>제 9조(개인정보보호)</dt>
        <dd>
          <p>
            1. "회사"는 회원의 정보수집 시 "회사" 서비스 이용에 필요한 최소한의 정보를 수집합니다.<br />
            다음 사항을 필수사항으로 하며 그 외 사항은 선택사항으로 합니다.
          </p>
          <p class="m20">
            ㉠ 성명<br />
            ㉡ 주민등록번호<br />
            ㉢ 주소<br />
            ㉣ 전화번호<br />
            ㉤ 희망ID<br />
            ㉥ 비밀번호<br />
            ㉦ 업종<br />
            ㉧ "회사" 인지 경로<br />
            ㉨ 이메일주소
          </p>
          <p>단, 회원이 개인사업자나 법인으로 가입 시 전자세금계산서의 발급을 위해 필요한 정보는 필수사항입니다.</p>
          <p>2. 수집된 개인정보는 회사에서 보유하며, 그외 당해 회원의 동의 없이 목적 외의 이용자나 제3자에게 제공할 수 없으며, 이에 대한 모든 책임은 "회사"가 집니다. 다만 다음의 경우에는 예외로 합니다.</p>
          <p class="m20">
            ㉠ 서비스 이용계약의 이행을 위하여 필요한 경우<br />
            ㉡ 서비스 제공에 따른 요금정산을 위하여 필요한 경우<br />
            ㉢ 기타 관련 법률에 특별한 규정이 있는 경우<br />
            ㉣ 배송업무상 배송업체에게 배송에 필요한 최소한의 회원의 정보(성명, 주소, 전화번호)를 알려주는 경우.<br />
            ㉤ 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정개인을 식별할 수 없는 형태로 제공하는 경우
          </p>
          <p>
            3. "회사"가 제2)항의 규정에 의한 동의를 얻고자 하는 경우에는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제 22조 2항이 규정한 사항을 미리 회원에게 고지하거나 명시하여야 하며 회원은 언제든지 이 동의를 철회할 수 있습니다.<br />
            4. 회원은 언제든지 "회사"가 갖고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며, "회사"는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다.
            <br />
            5. "회사"는 개인정보 보호를 위하여 관리자를 최소한으로 지정하여 운영하며 회원의 개인정보의 분실, 도난, 유출, 변조 등으로 인한 회원의 손해에 대하여 모든 책임을 집니다.<br />
            6. "회사" 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한때에는 당해 개인정보를 지체 없이 파기합니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 10 조 (회원 정보의 변경)</dt>
        <dd>
          <p>
            1. 회원은 이용신청 시 기재한 회원정보가 변경되었을 경우에는 그 변경내용을 회사 사이트에 접속하여 직접 수정해야하며, 직접 수정이 불가한 경우에는 "회사"에 반드시 통보해야 합니다. <br />
            회원 정보의 미 변경이나 허위기재 등으로 인하여 발생되는 문제의 책임은 모두 회원에게 있습니다.<br />
            2. 제 1)항과 관련하여 허위정보를 입력하였을 경우 경품이나 각종 이벤트에 당첨되더라도 "회사"에서 그 자격을 취소할 수 있습니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 11 조 (회원의 의무)</dt>
        <dd>
          <p>
            1. 회원은 관계법령, 이 약관에서 규정하는 사항, 서비스 이용안내 및 주의 사항을 준수 합니다.<br />
            2. 회원은 내용별로 "회사"가 서비스 공지사항에 게시하거나 별도로 공지한 이용제한 사항을 준수하여야 합니다.<br />
            3. 회원은 서비스 이용 시 다음 각 호의 행위를 하여서는 안 됩니다.
          </p>
          <p class="m20">
            ㉠ 신청 또는 변경 시 허위내용의 등록<br />
            ㉡ 다른 회원의 ID를 부정하게 사용하는 행위<br />
            ㉢ "회사"에 게시된 정보의 변경<br />
            ㉣ "회사"가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시<br />
            ㉤ "회사" 및 기타 제3자의 저작권 등 지적재산권에 대한 침해<br />
            ㉥ "회사" 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위<br />
            ㉦ 외설 또는 폭력적인 메시지, 화상, 음성 기타 공서양속에 반하는 정보를 회사의 싸이트에 공개 또는 게시하는 행위<br />
            ㉧ 공공질서 및 미풍양속에 위반되는 내용의 정보, 문장, 도형 등을 타인에게 유포하는 행위<br />
            ㉨ 사실관계를 왜곡하는 정보제공 행위 등 기타 "회사"가 부적절하다고 판단하는 행위
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 12 조 (저작권의 귀속 및 이용제한)</dt>
        <dd>
          <p>
            1. "회사"가 작성한 저작물에 대한 저작권 및 기타 지적재산권은 모두 "회사"에 귀속합니다. <br />
            2. 회원은 "회사"에서 얻은 정보를 "회사"의 사전승낙 없이 회원의 서비스 이용이외의 목적으로 복제하거나 이를 변경, 송신, 출판, 배포 및 방송 기타 방법 등에 의하여 영리목적으로 이용할 수 없으며, 회원사의 영리목적을 위한 제품 실현의 수단이 될 수 없습니다. <br />
            3. 기타 "회사"가 운영상 부적절하다고 판단한 정보를 "회사"에 게시하거나 링크 한 경우, "회사"는 부적절한 정보를 게시한 자의 승낙 없이 "회사"에 게재된 당해 정보나 링크된 정보를 삭제할 수 있습니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 13 조 (서비스의 요금 및 지급방법)</dt>
        <dd>
          <p>
            1 서비스 요금 및 이용기간 등은 회사와 회원간의 별도의 계약에 의한다.<br />
            2. 서비스 요금 지급방법은 다음 각 호의 하나로 할 수 있습니다.
          </p>
          <p class="m20">
            ㉠무통장입금<br />
            ㉡ 계좌이체 및 기타 회사에서 제공하는 결제방법
          </p>
          <p>
            3. 서비스 요금은 회원 당 1개의 ID의 사용으로 제한됩니다. <br />
            4. 1개의 동일한 ID로 동시에 접속하여 이용할 수 없습니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 14 조( 서비스)</dt>
        <dd>
          <p>
            1. "회사"는 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우와 전기통신사업법에 의한 기간통신 사업자가 전기통신서비스를 중지하는 등 기타 불가항력적 사유가 있는 경우 에는 서비스의 전부 또는 일부를 제한하거나 정지할 수 있습니다.<br />
            2. "회사"는 제 1)항의 규정에 의하여 서비스의 이용을 제한하거나 정지한 때에는 그 사유 및 제한기간 등을 지체 없이 회원에게 알려야 합니다.<br />
            3. "회사"의 과실로 인하여 다음과 같이 서비스의 장애가 발생 시 회원은 다음과 같이 보상을 요구할 수 있습니다.
          </p>
          <p class="m20">
            ㉠ 3일 이상 서비스 중지/장애가 발생한 경우 또는 1개월 동안 서비스 중지 장애 발생 누적시간이 72시간을 초과한 경우에 회원은 계약해지를 요구할 수 있으며, 위약금 없이 잔여기간의 이용요금을 환급받을 수 있습니다. <br />
            ㉡ 연속해서 4시간 이상 서비스 중지 - 장애가 발생한 경우 서비스가 중지되었거나 장애가 발생한 시간의 3배의 무료이용시간을 부여 합니다. <br />
            ㉢ 서비스 중지 장애 시간은 소비자가 "회사"에 통지한 후부터 계산하되, 업체의 사전고지가 있거나 천재지변, 소비자의 고의나 과실로 인한 장애 발생 시에는 서비스 중지 장애 시간에서 제외됩니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 15 조 (서비스 이용시간)</dt>
        <dd>
          <p>1) 서비스를 이용 중 계약 해지 등의 내용은 회사와 회원간에 작성한 별도의 계약 내용에 의한다.</p>
        </dd>
      </dl>
      <dl>
        <dt>제 16 조 (서비스 제한 및 정지)</dt>
        <dd>
          <p>
            1. 회원이 이용계약을 해지하고자 할 시 회사와 회원간에 별도로 작성한 계약서에 의한 계약 해지 성립과 동시에 탈퇴할 수 있다.<br />
            2. 회원이 다음 각 호의 사유에 해당하는 경우, "회사"는 사전 통지 없이 회원 자격을 제한 및 정지 시킬 수 있습니다.
          </p>
          <p class="m20">
            ㉠ 가입 신청 시 허위 내용을 등록한 경우<br />
            ㉡ 타인의 개인정보, 회원 ID 및 비밀번호를 부정하게 사용하는 경우<br />
            ㉢ 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우<br />
            ㉣ "회사", 다른 회원 또는 타인의 지적재산권을 침해하는 경우<br />
            ㉤ "회사"의 서비스 정보를 이용하여 얻은 정보를 "회사"의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우<br />
            ㉥ 서비스운영을 고의로 방해하거나 방해할 목적으로 다량의 정보를 전송하거나 광고성정보를 전송하는 경우<br />
            ㉦ 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시키는 등 "회사"를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우 <br />
            ㉧ 회원이 게시판에 음란물을 게재하거나 음란사이트를 링크하는 경우 <br />
            ㉨ 정보통신설비의 오작동이나 정보 등의 파괴를 유발시키는 컴퓨터 바이러스 프로그램 등을 유포하는 경우<br />
            ㉩ 회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행하는 경우<br />
            ㉪ 정보통신윤리위원회 등 외부기관의 시정요구가 있거나 불법선거 운동과 관련하여 선거관리위원회의 유권해석을 받은 경우<br />
            ㉫ 기타 전자거래질서를 위협하는 경우
          </p>
          <p>
            3. "회사"가 회원 자격을 제한 정지 시킨 후 , 동일한 행위가 2회 이상 반복되거나, 30일 이내에 그 사유가 시정되지 아니하는 경우 "회사"는 회원자격을 상실시킬 수 있습니다. <br />
            4. "회사"가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원 등록 말소 전에 소명할 기회를 부여합니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 17 조 (서비스의 해지)</dt>
        <dd>
          <p>
            1. "회사"가 회원에 대한 통지를 하는 경우 회원이 "회사"에 제공한 전자우편 주소로 통지할 수 있습니다. <br />
            2. "회사"는 불특정다수 회원에 대한 통지의 경우 1주일이상 “서비스” 공지사항에 게시함으로써 개별통지에 갈음할 수 있습니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 18 조 (회원 탈퇴 및 자격 상실)</dt>
        <dd>
          <p>
            1. 회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 "회사" 사이트 내에서 언제든지 해지를 할 수 있습니다. <br />
            2. 회원이 다음 각 호의 사유에 해당하는 경우, "회사"는 사전 통지 없이 회원 자격을 제한 및 정지 시킬 수 있습니다.
          </p>
          <p class="m20">
            ㉠ 가입 신청 시 허위 내용을 등록한 경우<br />
            ㉡ 타인의 개인정보, 회원 ID 및 비밀번호를 부정하게 사용하는 경우<br />
            ㉢ 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우<br />
            ㉣ "회사", 다른 회원 또는 타인의 지적재산권을 침해하는 경우<br />
            ㉤ "회사"의 서비스 정보를 이용하여 얻은 정보를 "회사"의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우<br />
            ㉥ 서비스운영을 고의로 방해하거나 방해할 목적으로 다량의 정보를 전송하거나 광고성정보를 전송하는 경우<br />
            ㉦ 공공질서 및 미풍양속에 저해되는 내용을 고의로 유포시키는 등 "회사"를 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우 <br />
            ㉧ 회원이 게시판에 음란물을 게재하거나 음란사이트를 링크하는 경우 <br />
            ㉨ 정보통신설비의 오작동이나 정보 등의 파괴를 유발시키는 컴퓨터 바이러스 프로그램 등을 유포하는 경우<br />
            ㉩ 회원이 국익 또는 사회적 공익을 저해할 목적으로 서비스 이용을 계획 또는 실행하는 경우<br />
            ㉪ 정보통신윤리위원회 등 외부기관의 시정요구가 있거나 불법선거 운동과 관련하여 선거관리위원회의 유권해석을 받은 경우<br />
            ㉫ 기타 전자거래질서를 위협하는 경우
          </p>
          <p>
            3. "회사"가 회원 자격을 제한 정지 시킨 후 , 동일한 행위가 2회 이상 반복되거나, 30일 이내에 그 사유가 시정되지 아니하는 경우 "회사"는 회원자격을 상실시킬 수 있습니다. <br />
            4. "회사"가 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원 등록 말소 전에 소명할 기회를 부여합니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 19 조(회원에 대한 통지)</dt>
        <dd>
          <p>
            1. "회사"가 회원에 대한 통지를 하는 경우 회원이 "회사"에 제공한 전자우편 주소로 통지할 수 있습니다. <br />
            2. "회사"는 불특정다수 회원에 대한 통지의 경우 1주일이상 “서비스” 공지사항에 게시함으로써 개별통지에 갈음할 수 있습니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 20 조 (면책)</dt>
        <dd>
          <p>
            1. "회사"는 회원이 "회사"의 서비스 제공으로부터 기대되는 이익을 얻지 못하였거나 서비스 자료에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해서는 책임이 면제됩니다. <br />
            2. "회사"는 회원의 귀책사유로 인하여 서비스 이용의 장애가 발생한 경우에는 책임이 면제됩니다.<br />
            3. "회사"는 회원이 게시 또는 전송한 자료의 내용에 대해서는 책임이 면제됩니다. <br />
            4. "회사"는 회원 상호간 또는 회원과 제3자 상호간에 서비스를 매개로 하여 물품거래 등을 한 경우에는 책임이 면제됩니다. <br />
            5. "회사"는 모든 서비스의 자료 보관 및 전송에 관한 책임이 없으며 자료의 손실이 있는 경우에도 책임이 면제됩니다. <br />
            6. "회사"는 천재지변 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없을 경우에는 서비스 제공중지에 관한 책임을 면합니다. <br />
            7. "회사"는 회원들의 귀책사유로 인한 서비스이용의 장애에 대하여 책임을 면합니다. <br />
            8. "회사"는 "회사"가 제공하는 서비스망을 통해 제공하는 정보의 신뢰도나 정확성에 대하여는 책임을 면합니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 21 조(분쟁해결)</dt>
        <dd>
          <p>
            1. "회사"는 회원이 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기위하여 고객센터를 설치 운영합니다.<br />
            2. "회사"는 회원으로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만 신속한 처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을 즉시 통보합니다.<br />
            3. "회사"와 회원 간에 발생한 분쟁은 전자거래분쟁위원회의 조정에 따를 수 있습니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>제 22 조(재판권 및 준거법)</dt>
        <dd>
          <p>
            1. "회사"와 회원 간에 발생한 전자거래 분쟁에 관한 소송은 회사의 본사 소재지를 관할하는 법원에 제기할 수 있습니다.<br />
            2. "회사"와 회원 간에 제기된 전자거래 소송에는 대한민국 법을 적용합니다.
          </p>
        </dd>
      </dl>
      <dl>
        <dt>『부칙』</dt>
        <dd>
          <p class="m20">㉠ (시행일) 이 약관은 2022년 7월 1일부터 적용됩니다.</p>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script setup lang="ts"></script>

<style>
dd {
  font-size: 13px;
}
</style>
